import { DeviceDetect } from "sb-resp-lib";
import { Event, Market } from "../../contracts";
import { ComponentType } from "../../data";

export class ComponentManager {
    private showLeagueInEventCard: boolean
    private outrightSelectionsCount: number
    private deviceDetect: DeviceDetect

    constructor (showLeagueInEventCard: boolean, outrightSelectionsCount: number, deviceDetect: DeviceDetect) {
        this.showLeagueInEventCard = showLeagueInEventCard;
        this.outrightSelectionsCount = outrightSelectionsCount;
        this.deviceDetect = deviceDetect;
    }

    getSubheadingHeight() {
        return this.deviceDetect.isDesktop ? 38 : 48;
    }

    getComponentHeight (event: Event, markets: Market[]): number {
        const params = event.componentType === ComponentType.PreLiveOutright
            ? markets
            : event;

        return this[`measure${event.componentType}`](params);
    }

    measureAggregateCard (event: Event): number {
        return 73; // Desktop version same as Mobile
    }

    measureCardTypes (event: Event): number {
        return event.cardType ? this[`measure${event.cardType}`]() : 0;
    }

    measureAmerican (): number {
        // TODO: Check if we need to consider markets, to set different heights:
        // 58 for 2 selections Desktop, 186 or 158 for Mobile
        // 84 for 3 selections Desktop, 222 or 194 for Mobile

        return this.deviceDetect.isDesktop
            ? 58
            : this.showLeagueInEventCard ? 186 : 158;
    }

    measureMultiview (): number {
        // TODO: Make sure that you see RegularCard on Mobile, instead of MultiviewCard
        if (!this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard ? 100 : 83;
        }
        return this.showLeagueInEventCard ? 66 : 60;
    }

    measureRegular (): number {
        if (this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard ? 78 : 65;
        }
        return this.showLeagueInEventCard ? 102 : 84;
    }

    measureAsian (): number {
        return this.measureRegular();
    }

    measureMiniCardTypes (): number {
        return 56;
    }

    measureMiniOutright (): number {
        return 36;
    }

    measureLiveOutright (): number {
        return !this.deviceDetect.isMobile ? 54 : 66;
    }

    measurePreLiveOutright (markets: Market[]): number {
        let selectionsCount = markets[0].selections.length;
        let showViewAll = selectionsCount > this.outrightSelectionsCount;

        if (this.deviceDetect.isDesktop) {
            return showViewAll ? 230 : this.setPreLiveOutrightHeight(selectionsCount, true);
        }
        return showViewAll ? 312 : this.setPreLiveOutrightHeight(selectionsCount, false);
    }

    private setPreLiveOutrightHeight (selectionsCount: number, isDesktop: boolean) {
        return isDesktop ? this.setPreLiveOutrightHeightDesktop(selectionsCount) : this.setPreLiveOutrightHeightMobile(selectionsCount);
    }

    private setPreLiveOutrightHeightDesktop(selectionsCount: number) {
        return (Math.ceil(selectionsCount / 2) - 1) * 49 + 53;
    }

    private setPreLiveOutrightHeightMobile(selectionsCount: number) {
        return (selectionsCount - 1) * 47 + 53;
    }
}